import React, { useState, Fragment } from 'react';
import Link from 'redux-first-router-link';
import { NavLink } from 'redux-first-router-link';
import PropTypes from 'prop-types';
import OutboundLink from '../common/OutboundLink';
import BrandLogo from './BrandLogo';
import Socials from './Socials';
import SearchForm from '../Search/SearchForm';
import GalleryLogo from './GalleryLogo';
import allTopicsData from "./data/Nav/allTopicsData";
import CorpLinks from './CorpLinks';
import { SITE_HOST } from '../../consts';


const trackNavClick = (destination_url, hypercontext, category, action, label, callback) => {
  const trackingProperties = {
    destination_url, 
    category,
    action,
    label
  }
  analytics.track('navigation', trackingProperties);
  callback();
}

export const Nav = ({
  onCloseClick,
  isMobile,
  showNav, 
  standardArticleTracker,
  showHeaderCat,
}) => {



  return (
    <div className={`nav ${!showNav ? 'hide' : ''}`} onTouchStart={(e) => {
      if (isMobile) {
        e.stopPropagation();
      }
    }}>
      <div className="nav-content">
        <div className="nav-close icon-close-icon-NEW" onClick={onCloseClick} />
        <SearchForm cssClass="nav-item" canCollapse={false} parent="nav" />
        <div className="nav-links-container">
          <div className='nav-links'>
            <span>
              { showHeaderCat && 
              <Fragment>
                <a
                  onClick={() => trackNavClick("/about-us", "/about-us", "navigation", "side bar", "about-us", onCloseClick)}
                  className="nav-link about-us"
                  href={`${SITE_HOST}/page/about-us`}>
                  About Us
                </a>
                <Link
                  onClick={() => trackNavClick("/style", "/style", "navigation", "side bar", "style", onCloseClick)}
                  className="nav-link style"
                  to={{ type: 'LANDER', payload: { category: 'style' } }}>
                  Style
                </Link>
                <Link
                  onClick={() => trackNavClick("/fashion", "/fashion", "navigation", "side bar", "fashion", onCloseClick)}
                  className="nav-link fashion"
                  to={{ type: 'LANDER', payload: { category: 'fashion' } }}>
                  Fashion
                </Link>
                <Link
                  onClick={() => trackNavClick("/beauty", "/beauty", "navigation", "side bar", "beauty", onCloseClick)}
                  className="nav-link beauty"
                  to={{ type: 'LANDER', payload: { category: 'beauty' } }}>
                  Beauty
                </Link>
                <a
                  onClick={() => trackNavClick("/reviews", "/reviews", "navigation", "side bar", "reviews", onCloseClick)}
                  className="nav-link reviews"
                  href={`${SITE_HOST}/reviews`}>
                  Reviews
                </a>
                <a
                  onClick={() => trackNavClick("/shopping", "/shopping", "navigation", "side bar", "shopping", onCloseClick)}
                  className="nav-link shopping"
                  href={`${SITE_HOST}/shopping`}>
                  Shopping
                </a>
                <Link
                  onClick={() => trackNavClick("/food", "/food", "navigation", "side bar", "food", onCloseClick)}
                  className="nav-link food"
                  to={{ type: 'LANDER', payload: { category: 'food' } }}>
                  Food
                </Link>
                <Link
                  onClick={() => trackNavClick('/family', '/family', "navigation", "side bar", "family", onCloseClick)}
                  className="nav-link family"
                  to={{ type: 'LANDER', payload: { category: 'family' } }}>
                  Family
                </Link>
                <Link
                  onClick={() => trackNavClick('/wellness', '/wellness', "navigation", "side bar", "wellness", onCloseClick)}
                  className="nav-link wellness"
                  to={{ type: 'LANDER', payload: { category: 'wellness' } }}>
                  Wellness
                </Link>
              </Fragment>
              }
              <Link
                onClick={() => trackNavClick("/entertainment", "/entertainment", "navigation", "side bar", "entertainment", onCloseClick)}
                className="nav-link entertainment"
                to={{ type: 'LANDER', payload: { category: 'entertainment' } }}>
                Entertainment
              </Link>
              <Link
                onClick={() => trackNavClick("/news", "/news", "navigation", "side bar", "news", onCloseClick)}
                className="nav-link news"
                to={{ type: 'LANDER', payload: { category: 'news' } }}>
                News
              </Link>
              <Link
                onClick={() => trackNavClick('/home', '/home', "navigation", "side bar", "home", onCloseClick)}
                className="nav-link home"
                to={{ type: 'LANDER', payload: { category: 'home' } }}>
                Home
              </Link>
              <Link
                onClick={() => trackNavClick('/recipes', '/recipes', "navigation", "side bar", "recipes", onCloseClick)}
                className="nav-link recipes"
                to={{ type: 'LANDER', payload: { category: 'recipes' } }}>
                Recipes
              </Link>
              <Link
                onClick={() => trackNavClick('/travel', '/travel', "navigation", "side bar", "travel", onCloseClick)}
                className="nav-link travel"
                to={{ type: 'LANDER', payload: { category: 'travel' } }}>
                Travel
              </Link>
              <Link
                onClick={() => trackNavClick('/pets', '/pets', "navigation", "side bar", "pets", onCloseClick)}
                className="nav-link pets"
                to={{ type: 'LANDER', payload: { category: 'pets' } }}>
                Pets
              </Link>
              <Link
                onClick={() => trackNavClick('/horoscopes', '/horoscopes', "navigation", "side bar", "horoscopes", onCloseClick)}
                className="nav-link horoscopes"
                to={{ type: 'LANDER', payload: { category: 'horoscopes' } }}>
                Horoscopes
              </Link>
              <Link
                onClick={() => trackNavClick('/home/holiday-gift-guide', '/home/holiday-gift-guide', "navigation", "side bar", "gift-guide", onCloseClick)}
                className="nav-link gift-guide"
                to="/home/holiday-gift-guide">
                Gift Guides
              </Link>
              <Link
                onClick={() => trackNavClick('/weddings', '/weddings', "navigation", "side bar", "weddings", onCloseClick)}
                className="nav-link weddings"
                to={{ type: 'LANDER', payload: { category: 'weddings' } }}>
                Weddings
              </Link>
              <Link
                onClick={() => trackNavClick('/cultures', '/cultures', "navigation", "side bar", "cultures", onCloseClick)}
                className="nav-link cultures"
                to={{ type: 'LANDER', payload: { category: 'cultures' } }}>
                Cultures
              </Link>
              <Link
                onClick={() => trackNavClick('/money', '/money', "navigation", "side bar", "money", onCloseClick)}
                className="nav-link money"
                to={{ type: 'LANDER', payload: { category: 'money' } }}>
                Money
              </Link>
              <Link
                onClick={() => trackNavClick('/books', '/books', "navigation", "side bar", "books", onCloseClick)}
                className="nav-link books"
                to={{ type: 'LANDER', payload: { category: 'books' } }}>
                Books
              </Link>
              <Link
                onClick={() => trackNavClick('/tech', '/tech', "navigation", "side bar", "tech", onCloseClick)}
                className="nav-link tech"
                to={{ type: 'LANDER', payload: { category: 'tech' } }}>
                Tech
              </Link>
              <Link
                onClick={() => trackNavClick('/ny', '/ny', "navigation", "side bar", "new york", onCloseClick)}
                className="nav-link ny"
                to={{ type: 'LANDER', payload: { category: 'ny' } }}>
                New York
              </Link>
              <Link
                onClick={() => trackNavClick('/la', '/la', "navigation", "side bar", "los angeles", onCloseClick)}
                className="nav-link la"
                to={{ type: 'LANDER', payload: { category: 'la' } }}>
                Los Angeles
              </Link>
            </span>
          </div>
        </div>
        <div className='nav-bottom'>
          <a className='nav-subscribe' href='/subscribe'>SUBSCRIBE</a>
          <BrandLogo onClick={onCloseClick} />
          {isMobile && 
            <Socials parent="Nav" canCollapse={false} />
          }
        </div>
      </div>
    </div>
  )

};

Nav.propTypes = {
  onCloseClick: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default Nav;
